import React from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Cards from "../components/Cards";
import OurVision from "../components/OurVision";
// import becomeMentor from "../assets/images/heroImage.png";
import bg from "../assets/images/bg.jpg";

function BecomeMentor() {
  return (
    <div>
      <Header />
      <div
        class="mx-auto h-screen flex items-center"
        style={{ backgroundImage: `url(${bg})` }}
      >
        <div class="w-full text-gray-800 text-center sm:text-center sm:h-96 mb-72 sm:mb-0">
          <h1 class="sm:text-6xl text-3xl font-bold mb-4">
            Your next chapter, made possible
            <br />
            by{" "}
            <span className="bg-gradient-to-r from-blue-500 to-blue-900 text-transparent bg-clip-text">
              Mentoring
            </span>
          </h1>
          <p class="text-lg inline-block sm:block px-5 sm:px-0">
            The largest online community to get mentorship from world class
            mentors like you.
          </p>
          <a href="#applyForMentor">
            <button class="mt-8 px-4 py-3 text-white bg-gradient-to-r from-blue-500 to-blue-900 rounded">
              Become a Mentor
            </button>
          </a>
        </div>
      </div>

      {/* <div class="container py-12 items-center px-4 px-10 mx-auto sm:px-20 md:px-32 lg:px-16">
        <div class="flex flex-wrap items-center -mx-3">
          <div class="order-1 w-full px-3 lg:w-1/2 lg:order-0">
            <div class="w-full lg:max-w-md">
              <h2 class="mb-4 text-3xl font-bold leading-tight tracking-tight sm:text-4xl font-heading">
                Mentors can meet and learn from fellow mentors too!
              </h2>
              <p class="mb-4 font-medium tracking-tight text-gray-400 xl:mb-6">
                Mentoring can help you turn your passion into conversations,
                friendships and network globally.
              </p>
              <ul>
                <li class="flex items-center py-2 space-x-4 xl:py-3">
                  <svg
                    class="w-8 h-8 text-pink-500"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z"
                    ></path>
                  </svg>
                  <span class="font-medium text-gray-500">
                    It’s easier than you think. Join us. We’ll help you every
                    step of the way.
                  </span>
                </li>
                <li class="flex items-center py-2 space-x-4 xl:py-3">
                  <svg
                    class="w-8 h-8 text-yellow-500"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
                    ></path>
                  </svg>
                  <span class="font-medium text-gray-500">
                    It’s easier than you think. Join us. We’ll help you every
                    step of the way.
                  </span>
                </li>
                <li class="flex items-center py-2 space-x-4 xl:py-3">
                  <svg
                    class="w-8 h-8 text-green-500"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                    ></path>
                  </svg>
                  <span class="font-medium text-gray-500">
                    It’s easier than you think. Join us. We’ll help you every
                    step of the way.
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div class="w-full px-3 mb-12 lg:w-1/2 order-0 lg:order-1 lg:mb-0">
            <img
              class="mx-auto sm:w-3/4 lg:w-3/4"
              src={becomeMentor}
              alt="featureImage"
            />
          </div>
        </div>
      </div> */}

      <OurVision />
      <Cards />
      <div className="container px-5 py-12 mx-auto">
        <div
          id="applyForMentor"
          class="px-6 py-6 bg-gradient-to-r from-blue-500 to-blue-900  rounded-lg md:py-12 md:px-12 lg:py-16 lg:px-16 sm:flex sm:items-center"
        >
          <div class="xl:w-0 xl:flex-1">
            <h3 className="text-2xl font-extrabold tracking-tight text-white sm:text-4xl sm:leading-9">
              Take the next step
            </h3>
            <h2 class="text-lg leading-tight text-gray-100 mt-2">
              It’s easier than you think. Join us.
              <br /> We’ll help you every step of the way.
            </h2>
          </div>
          <div class="mt-8 sm:w-full sm:max-w-md xl:mt-0 xl:ml-8 sm:ml-20">
            <div class="mt-3 rounded-md shadow sm:mt-0 sm:flex-shrink-0">
              <a
                href="/signup"
                class="w-full flex items-center justify-center px-5 py-3 border border-transparent text-white leading-6 font-medium rounded-md text-white bg-blue-500 hover:bg-blue-400 focus:outline-none focus:bg-blue-500 transition duration-150 ease-in-out"
              >
                Apply for Mentor
              </a>
            </div>
            <p class="mt-3 text-sm leading-5 text-gray-100">
              Read all terms and conditions before applying for Mentor. We care
              about the protection of your data.
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default BecomeMentor;
